/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function SlidingCoverPreview({ srcs, redirectUrl }) {
  const [showImage, setShowImage] = useState(true)
  const firstImage = srcs.length > 0 ? srcs[0] : null
  const firstImageURL = (() => {
    if (!firstImage || !firstImage.file) return null
    if (firstImage.file instanceof Blob || firstImage.file instanceof File)
      return URL.createObjectURL(firstImage.file)
    if (typeof firstImage.file === 'string') return firstImage.file
    return null
  })()

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '470px', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {showImage && firstImageURL && (
        <div
          role="presentation"
          className="carpet-layer position-relative"
          style={{
            width: '240px',
            height: '520px',
            backgroundImage: `url(${firstImageURL})`,
            backgroundSize: '240px',
            backgroundPositionX: '68.75%',
            backgroundPositionY: '45%',
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat',
            marginTop: '20px',
            borderRadius: '0px',
          }}
          onClick={() => {
            if (redirectUrl) window.open(redirectUrl, '_blank')
          }}
        >
          <CIIcon />
        </div>
      )}

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

export default SlidingCoverPreview
